import makeStyles from '@mui/styles/makeStyles';
import Images from '../../../commons/images';

const styles = (theme) => ({
    copiedIcon: {
        width: '14px',
        height: '14px',
        color: '#FFFFFF',

        '&.MuiSvgIcon-root': {
            width: '16.8px', // this size is set so that the SVG inside will be 14x14pxg
            height: '16.8px',
        },
    },

    iconImage: {
        display: 'inline-block',
        flexShrink: 0,
        width: '16px',
        height: '16px',
        marginRight: '6px',
        WebkitMaskImage: `url(${Images.COPY_LINK_ICON})`,
        maskImage: `url(${Images.COPY_LINK_ICON})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
